import { css } from '@microsoft/fast-element';
export const dropdownMenuBaseStyles = (prefix, context, definition) => css `
  :host {
    --dropdown-opener-height-multiplier: 0.7px;
    --menu-item-height-multiplier: 0.7px;
  }

  .actions-menu {
    display: inline-flex;
    flex-direction: column;
    max-height: calc(
      var(--max-height) -
        ((var(--base-height-multiplier) + var(--density)) * var(--design-unit) * 1px)
    );
    position: absolute;
    z-index: 1;
    gap: calc(var(--design-unit) * 1px);
  }

  .hidden {
    display: none;
  }

  .actions-opener {
    display: flex;
    justify-content: center;
    height: calc(
      (var(--base-height-multiplier) + var(--density)) * var(--design-unit) *
        var(--dropdown-opener-height-multiplier)
    );
    max-width: 120px;
  }

  ${prefix}-menu-item {
    display: flex;
    user-select: none;
  }

  ${prefix}-menu-item::part(content) {
    margin-inline: 5px;
  }

  ${prefix}-menu-item::part(expand-collapse-glyph-container) {
    margin-inline-end: 5px;
  }

  ${prefix}-menu-item::part(expand-collapse) {
    margin-inline-start: 5px;
  }

  ${prefix}-menu-item[disabled] {
    pointer-events: none;
  }

  ${prefix}-icon {
    padding-left: 5px;
  }

  .menu-item {
    max-height: calc(
      (var(--base-height-multiplier) + var(--density)) * var(--design-unit) *
        var(--menu-item-height-multiplier)
    );
  }
`;
export const foundationDropdownMenuStyles = (context, definition) => css `
  ${dropdownMenuBaseStyles('foundation', context, definition)}
`;
